import { MdoInterimReportAdvice, mdoInterimReportAdviceWithColor } from '@common/customControls/bariatrics';

export const resumeMdoInterimAdviceWithColor = mdoInterimReportAdviceWithColor.filter(
    (item) => item.value !== MdoInterimReportAdvice.notYet && item.value !== MdoInterimReportAdvice.continueWithGuidance
);
